import { useEffect, useState } from "react";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Slider } from "../components/ui/slider";
import { Download, QrCode } from "lucide-react";
import { API, getClientId, downloadFile } from "../lib/api";

export default function QRGeneratorPage() {
  const [text, setText] = useState("https://handy.app");
  const [size, setSize] = useState(8);
  const [src, setSrc] = useState("");

  useEffect(() => {
    const t = text.trim() ? text : "https://handy.app";
    const url = `${API}/qr?text=${encodeURIComponent(t)}&size=${size}`;
    setSrc(url);
  }, [text, size]);

  async function download() {
    const url = `${API}/qr?text=${encodeURIComponent(text || "https://handy.app")}&size=${size}`;
    try {
      const res = await fetch(url);
      const blob = await res.blob();
      const href = URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = href; a.download = "qr.png"; document.body.appendChild(a); a.click(); a.remove();
      setTimeout(() => URL.revokeObjectURL(href), 1000);
    } catch (e) { /* ignore */ }
  }

  return (
    <div className="animate-fade-up max-w-3xl">
      <div className="mb-8">
        <span className="label-caps">Tool</span>
        <h1 className="mt-2 text-3xl sm:text-4xl lg:text-5xl font-display font-black tracking-tighter">QR Generator.</h1>
        <p className="mt-2 text-[color:var(--text-muted)]">Turn any text or link into a scannable QR code.</p>
      </div>

      <div className="card-tactile rounded-2xl p-6 grid grid-cols-1 md:grid-cols-[1fr_220px] gap-6 items-start">
        <div className="space-y-4">
          <div>
            <label className="label-caps mb-2 block">Text or URL</label>
            <Input value={text} onChange={(e) => setText(e.target.value)} placeholder="https://example.com" data-testid="qr-text" />
          </div>
          <div>
            <label className="label-caps mb-2 block">Size ({size})</label>
            <Slider value={[size]} onValueChange={(v) => setSize(v[0])} min={4} max={16} step={1} data-testid="qr-size" />
          </div>
          <Button onClick={download} data-testid="qr-download" className="bg-[color:var(--primary)] hover:bg-[color:var(--primary-hover)] text-white">
            <Download className="h-4 w-4 mr-2" /> Download PNG
          </Button>
        </div>
        <div className="rounded-xl border border-[color:var(--border-subtle)] bg-white p-4 flex items-center justify-center" data-testid="qr-preview">
          {src ? <img src={src} alt="QR code" className="max-w-full max-h-52 object-contain" /> : <QrCode className="h-12 w-12 text-[color:var(--text-muted)]" />}
        </div>
      </div>
    </div>
  );
}
